import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookAiImageOpened} from "../../aiActions";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../../config";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {UserPopupContent, UserPopupTypes} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";
import UserLoginButton from "../../../ui/userLoginButton";
import {toggleUserPopup} from "../../../../actions/actionFunctions";


const LookAIImageOverlayLoginContent = (props) => {

  const {setLookAiImageOpened, aiUserFileBlobUrl, setLookOverlayOpened, setUserPopupContent, aiResults, isMobile, toggleUserPopup} = props;

  const loginButtonClick = (action) => {
    setLookAiImageOpened(false);
    setUserPopupContent(action);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, "aiLeadCapture");
    if (IS_QKB_UI) {
      UserLoginButton.handleLoginClick({
        toggleUserPopup,
        saveQuoteAfterLogin: true,
        userPopupType: UserPopupTypes.AIDesign
      })
    }
  }

  const visualizerType = getCommonVisualizerType();

  const activeResult = aiResults.find(aiResult => aiResult.isActive);

  return (
    <div className="flex--1 relative w-full h-full bg-center bg-cover bg-no-repeat rounded-025"
         style={{backgroundImage: `url(${activeResult ? activeResult.resultImageUrl : aiUserFileBlobUrl})`}}>
      {/* Sharp background layer */}
      {/* Blurred layer with masking */}
      <div className="absolute look-ai__overlay-blur w-full h-full bg-cover bg-center bg-no-repeat rounded-025"
           style={{backgroundImage: `url(${activeResult ? activeResult.resultImageUrl :aiUserFileBlobUrl})`}}/>
      {/* Content layer */}
      <div className="relative look-ai__overlay-login p-1 absolute flex flex--center left-0 w-full text-center">
        <div className="m-auto max-640 w-full">
          <h3 className={"mt-0 mb-1 bold" + (isMobile ? "" : " font--24")
            + (IS_QKB_UI ? " color-primary" : " color-active_text")}>
            <FormattedMessage id="look.ai.overlay.loginTitle" values={{visualizerType}}/>
          </h3>
          <p className={"m-0 font--16 text-left" + (isMobile ? "" : " pr-4 pl-4")} style={{color: "#6B7B8D"}}>
            <FormattedMessage id="look.ai.overlay.loginText" values={{visualizerType}}/>
          </p>
          <div className={isMobile ? "mt-05 mb-05" : "mt-2 mb-2"}>
            <Button className={"look-button look-button--blue look-button--10-radius look-button--160 nowrap"
              + (IS_QKB_UI ? " pl-15 pr-15 ui-button2 ui-button2--green ui-button2--white" : "")}
                    onClick={() => loginButtonClick(UserPopupContent.register)}>
              <FormattedMessage id="look.ai.overlay.loginButton"/>
            </Button>
          </div>
          <p className="m-0">
            <span style={{color: "#6B7B8D"}} className="pr-05">
              <FormattedMessage id="leadCapturePopup.loginText2"/>
            </span>
            <span className={"link cursor-pointer text-uppercase"
              + (IS_QKB_UI ? " hover:color-primary" : " hover:color-active_text")}
                  onClick={() => loginButtonClick(UserPopupContent.login)}>
              <FormattedMessage id="leadCapturePopup.loginButton"/>
            </span>
          </p>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiUserFileBlobUrl, aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    aiUserFileBlobUrl,
    aiResults,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
  setLookOverlayOpened,
  setUserPopupContent,
  toggleUserPopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImageOverlayLoginContent)
)
